import { apiV4 } from "../axios";

export function getBlogs(busca: string = "", pagina: number = 1, quantidade: number = 9) {
    return apiV4.get(`/blog?busca=${busca}&pagina=${pagina}&quantidade=${quantidade}`);
}

export function getBlog(slug: string) {
    return apiV4.get(`/blog/detalhes?slug=${slug}`);
}